import React from 'react';
import { compose } from 'recompose';
import { withStyles } from '@material-ui/core/styles';
import TableHead from '@material-ui/core/TableHead';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import { TableSortLabel } from '@material-ui/core';
import { onePayEnabled, wechatPayEnabled } from '../../constants/PaymentTypes';

const styles = {};

const enhance = compose();

const tableHead = enhance(
  ({ order, orderBy, onRequestSort, roles, onRequestSortClient }) => {
    return (
      <TableHead>
        <TableRow>
          <TableCell />
          {(roles.isSecretariat || roles.isDeveloper) && (
            <TableCell sortDirection={orderBy === 'shopId' ? order : false}>
              <TableSortLabel
                active={orderBy === 'shopId'}
                direction={order}
                onClick={() => {
                  onRequestSort('shopId');
                }}
              >
                店舗ID
              </TableSortLabel>
            </TableCell>
          )}
          {(roles.isGroup || roles.isSecretariat || roles.isDeveloper) && (
            <TableCell sortDirection={orderBy === 'groupName' ? order : false}>
              <TableSortLabel
                active={orderBy === 'groupName'}
                direction={order}
                onClick={() => {
                  onRequestSort('groupName');
                }}
              >
                運営会社名
              </TableSortLabel>
            </TableCell>
          )}
          <TableCell sortDirection={orderBy === 'shopName' ? order : false}>
            <TableSortLabel
              active={orderBy === 'shopName'}
              direction={order}
              onClick={() => {
                onRequestSort('shopName');
              }}
            >
              店舗名
            </TableSortLabel>
          </TableCell>
          <TableCell
            sortDirection={orderBy === 'streetAddress' ? order : false}
          >
            <TableSortLabel
              active={orderBy === 'streetAddress'}
              direction={order}
              onClick={() => {
                onRequestSortClient('streetAddress');
              }}
            >
              住所
            </TableSortLabel>
          </TableCell>
          <TableCell sortDirection={orderBy === 'phone' ? order : false}>
            <TableSortLabel
              active={orderBy === 'phone'}
              direction={order}
              onClick={() => {
                onRequestSort('phone');
              }}
            >
              電話番号
            </TableSortLabel>
          </TableCell>
          <TableCell />
          <TableCell />
          {(roles.isGroup || roles.isSecretariat || roles.isDeveloper) && (
            <TableCell />
          )}
          {roles.isSecretariat && <TableCell />}
          {roles.isSecretariat && (
            <TableCell style={{ paddingLeft: '28px' }}>
              こどもごちめし参加設定
            </TableCell>
          )}
          {roles.isSecretariat && (
            <TableCell style={{ paddingLeft: '28px' }}>
              こどもごちめし
              <br />
              1,001円以上
            </TableCell>
          )}
          {roles.isSecretariat && (
            <TableCell style={{ paddingLeft: '28px' }}>
              こどもごちめし
              <br />
              レシート対応
            </TableCell>
          )}
          {roles.isSecretariat && (
            <TableCell style={{ paddingLeft: '28px' }}>
              社食ごちめし法人表示設定
            </TableCell>
          )}
          {roles.isSecretariat && (
            <TableCell style={{ paddingLeft: '28px' }}>開店状況変更</TableCell>
          )}
          <TableCell>差額決済機能利用可否</TableCell>
          <TableCell>Paypay決済導入</TableCell>
          {onePayEnabled && <TableCell>Alipay決済導入</TableCell>}
          {wechatPayEnabled && <TableCell>WeChat Pay決済導入</TableCell>}
          {roles.isSecretariat && <TableCell />}
        </TableRow>
      </TableHead>
    );
  }
);

export default withStyles(styles)(tableHead);
